import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { isFetching } from 'utils/redux/fetching'
import { fetchRates } from 'redux/actions/rates'
import { fetchCurrencies } from 'redux/actions/currencies'
import Loader from 'components/Loader'
import CurrencyList from 'components/CurrencyList'
import MobileCurrencyListContainer from 'containers/MobileCurrencyListContainer'

class CurrencyListContainer extends Component {

	componentWillMount() {
		const { dispatch } = this.props
		dispatch(fetchCurrencies())
		dispatch(fetchRates())
	}
	render() {
		if (this.props.isFetching) return <Loader />
		const windowWidth = window.innerWidth
		const breakPoint = 980 
		
		return <div className='u-bg--white u-padding u-border-radius u-box-shadow'>
			{ (windowWidth < breakPoint) &&
				<MobileCurrencyListContainer {...this.props} />
			}
			{ (windowWidth >= breakPoint) &&
				<CurrencyList {...this.props}/>}
		</div>
	}
}

CurrencyListContainer.propTypes = {
	dispatch: PropTypes.func,
	isFetching: PropTypes.bool
}

const mapStateToProps = state => {

	const { rates, currencies } = state

	if (isFetching([rates, currencies])) return { isFetching: true }

	return {
		rates: rates.data
	}
}

export default connect(mapStateToProps)(CurrencyListContainer)
